<mat-toolbar>
  <mat-toolbar-row>
    <app-logo></app-logo>
    <span class="project-name">
      @if (isSandbox) {
        {{ "NAVBAR.IS_SANDBOX" | translate }}
      }
    </span>
    <span class="spacer"></span>
    @if (accounts().length > 1) {
      <mat-form-field
        class="account-select"
        subscriptSizing="dynamic"
        appearance="outline"
      >
        <mat-label>{{ "NAVBAR.ACCOUNT" | translate }}</mat-label>
        <mat-select
          [value]="activeAccountId()"
          (selectionChange)="selectAccount($event.value)"
          hideSingleSelectionIndicator="true"
        >
          @if (accountGroups(); as groups) {
            @for (group of groups; track group.label) {
              <mat-optgroup [label]="group.label | translate">
                @for (account of group.accounts; track account.id) {
                  <mat-option
                    [value]="account.id"
                    [disabled]="account.status !== 'ACTIVE'"
                  >
                    {{ account.name }}
                    @if (account.main) {
                      <span class="account-tag">
                        {{ "NAVBAR.MAIN_ACCOUNT" | translate }}
                      </span>
                    }
                  </mat-option>
                }
              </mat-optgroup>
            }
          } @else {
            @for (account of accounts(); track account.id) {
              <mat-option [value]="account.id" [disabled]="account.status !== 'ACTIVE'">
                {{ account.name }}
                @if (account.main) {
                  <span class="account-tag">{{ "NAVBAR.MAIN_ACCOUNT" | translate }}</span>
                }
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field
      class="timezone-select"
      subscriptSizing="dynamic"
      appearance="outline"
    >
      <mat-label> {{ "NAVBAR.TIMEZONE" | translate }}</mat-label>
      <mat-select [formControl]="timezoneControl" hideSingleSelectionIndicator="true">
        @for (timezone of supportedTimezones; track timezone) {
          <mat-option [value]="timezone">
            {{ timezone | translateTimezone }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-user-profile />
  </mat-toolbar-row>
</mat-toolbar>
